var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2274(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274",
    transform: "translate(-124 -159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 20,
    height: 20,
    transform: "translate(124 159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "clock-fill",
    d: "M16,8A8,8,0,1,1,8,0a8,8,0,0,1,8,8ZM8,3.5a.5.5,0,0,0-1,0V9a.5.5,0,0,0,.252.434l3.5,2a.5.5,0,0,0,.5-.868L8,8.71Z",
    transform: "translate(126.141 161)",
    fill: "#586973"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2274);
export default __webpack_public_path__ + "static/media/Group 2274.985dfb2e.svg";
export { ForwardRef as ReactComponent };